const travel = [
  {
    "web-scraper-order": "1666025813-880",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛅 Left Luggage",
    "travel-href": "https://emojipedia.org/left-luggage/",
    emoji: "🛅",
    emojiName: "🛅 Left Luggage",
    description:
      "An icon representing a place to leave luggage. Most commonly found at Japanese train stations to signify coin lockers where bags can be stored for a daily fee.",
  },
  {
    "web-scraper-order": "1666025817-882",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛄 Baggage Claim",
    "travel-href": "https://emojipedia.org/baggage-claim/",
    emoji: "🛄",
    emojiName: "🛄 Baggage Claim",
    description:
      "Baggage Claim was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025820-884",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛃 Customs",
    "travel-href": "https://emojipedia.org/customs/",
    emoji: "🛃",
    emojiName: "🛃 Customs",
    description:
      "A customs officer inspecting luggage. May be shown on signage at airports or other border crossings.",
  },
  {
    "web-scraper-order": "1666025823-886",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛂 Passport Control",
    "travel-href": "https://emojipedia.org/passport-control/",
    emoji: "🛂",
    emojiName: "🛂 Passport Control",
    description: "A person checking passports at an international border.",
  },
  {
    "web-scraper-order": "1666025826-887",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗿 Moai",
    "travel-href": "https://emojipedia.org/moai/",
    emoji: "🗿",
    emojiName: "🗿 Moai",
    description:
      "A moai, one of the famed, giant stone statues of human figures on Easter Island. Depicted as a gray stone carving of a stylized human head with a prominent brow and nose, most often facing left.",
  },
  {
    "web-scraper-order": "1666025830-889",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💷 Pound Banknote",
    "travel-href": "https://emojipedia.org/pound-banknote/",
    emoji: "💷",
    emojiName: "💷 Pound Banknote",
    description:
      "Quids in! A banded stack of pound banknotes, the paper currency of the United Kingdom (England, Wales, Northern Ireland, and Scotland). Color and detail vary across platforms, but widely depicted as purple £20 notes with the pound sign, £.",
  },
  {
    "web-scraper-order": "1666025833-891",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💶 Euro Banknote",
    "travel-href": "https://emojipedia.org/euro-banknote/",
    emoji: "💶",
    emojiName: "💶 Euro Banknote",
    description:
      "A banded stack of euro banknotes, the paper currency of the European Union (EU). Color and detail vary across platforms, but shown with the euro sign, €. Commonly used for various content concerning wealth and money, not restricted to the EU.",
  },
  {
    "web-scraper-order": "1666025836-892",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💵 Dollar Banknote",
    "travel-href": "https://emojipedia.org/dollar-banknote/",
    emoji: "💵",
    emojiName: "💵 Dollar Banknote",
    description:
      "Cash money! A banded stack of U.S. dollar banknotes, the paper currency of the United States of America. Green hue and detail vary across platforms, but shown with the dollar sign, $. Commonly used for various content concerning wealth and money, not restricted to the U.S.",
  },
  {
    "web-scraper-order": "1666025839-893",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💴 Yen Banknote",
    "travel-href": "https://emojipedia.org/yen-banknote/",
    emoji: "💴",
    emojiName: "💴 Yen Banknote",
    description:
      "A banded stack of yen banknotes, the paper currency of Japan. Color and detail vary across platforms, but usually shown in green, yellow, or pink with the yen symbol, ¥. Commonly used for various content concerning money and wealth, not restricted to Japan.",
  },
  {
    "web-scraper-order": "1666025842-895",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎑 Moon Viewing Ceremony",
    "travel-href": "https://emojipedia.org/moon-viewing-ceremony/",
    emoji: "🎑",
    emojiName: "🎑 Moon Viewing Ceremony",
    description:
      "Moon Viewing Ceremonies (called Tsukimi in Japan) are held each year in autumn to celebrate the full moon and waxing moon in Japan.",
  },
  {
    "web-scraper-order": "1666025844-896",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎇 Sparkler",
    "travel-href": "https://emojipedia.org/sparkler/",
    emoji: "🎇",
    emojiName: "🎇 Sparkler",
    description:
      "A  sparkler: a form of hand-held firework often used at parties and celebrations. The sparkler is lit at one end, and held at the other.",
  },
  {
    "web-scraper-order": "1666025861-901",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎆 Fireworks",
    "travel-href": "https://emojipedia.org/fireworks/",
    emoji: "🎆",
    emojiName: "🎆 Fireworks",
    description:
      "Firework emoji, showing a explosion of colored light in the night sky, used for any number of celebrations such as New Year's Eve.",
  },
  {
    "web-scraper-order": "1666025864-903",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛱️ Umbrella on Ground",
    "travel-href": "https://emojipedia.org/umbrella-on-ground/",
    emoji: "⛱️",
    emojiName: "⛱️ Umbrella on Ground",
    description:
      "A large, open umbrella, as provides shade at a beach or patio. Generally depicted as a striped umbrella inserted into a patch of sand and tilted to the right.",
  },
  {
    "web-scraper-order": "1666025867-904",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌌 Milky Way",
    "travel-href": "https://emojipedia.org/milky-way/",
    emoji: "🌌",
    emojiName: "🌌 Milky Way",
    description:
      "The Milky Way – a galaxy of billions of stars that includes our own solar system and planet earth.",
  },
  {
    "web-scraper-order": "1666025873-906",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌠 Shooting Star",
    "travel-href": "https://emojipedia.org/shooting-star/",
    emoji: "🌠",
    emojiName: "🌠 Shooting Star",
    description:
      "A stylized representation of a shooting star, a small, fast meteor that burns up in the atmosphere. Generally depicted as a gold, five-point star trailing yellow motion lines against a night sky, as if moving down to the left.",
  },
  {
    "web-scraper-order": "1666025877-908",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🪐 Ringed Planet",
    "travel-href": "https://emojipedia.org/ringed-planet/",
    emoji: "🪐",
    emojiName: "🪐 Ringed Planet",
    description:
      "A ringed planet that appears with various number of rings, tilt angles, and colors across platforms. This vaguely Saturn-like orb was proposed as a stand-alone planet emoji to represent all planets.",
  },
  {
    "web-scraper-order": "1666025881-910",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛸 Flying Saucer",
    "travel-href": "https://emojipedia.org/flying-saucer/",
    emoji: "🛸",
    emojiName: "🛸 Flying Saucer",
    description:
      "A flying saucer, sometimes referred to as an Unidentified Flying Object (UFO). Previously shown on some platforms with an alien at the controls and/or a beam of light emitting from the base.",
  },
  {
    "web-scraper-order": "1666025887-912",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚀 Rocket",
    "travel-href": "https://emojipedia.org/rocket/",
    emoji: "🚀",
    emojiName: "🚀 Rocket",
    description:
      "A rocket being propelled into space. Sometimes used to indicate a fast increase, for instance when referring to stocks going to the moon 🚀 (rising quickly in price).",
  },
  {
    "web-scraper-order": "1666025889-914",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛰️ Satellite",
    "travel-href": "https://emojipedia.org/satellite/",
    emoji: "🛰️",
    emojiName: "🛰️ Satellite",
    description:
      "A satellite which orbits the earth, and is generally used for communications, weather, and GPS.",
  },
  {
    "web-scraper-order": "1666025893-915",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚡 Aerial Tramway",
    "travel-href": "https://emojipedia.org/aerial-tramway/",
    emoji: "🚡",
    emojiName: "🚡 Aerial Tramway",
    description:
      "An Aerial Tramway, most commonly seen at ski resorts, for transport between locations on a mountain. Can also be used as a tourist attraction, or as a form of public transport.",
  },
  {
    "web-scraper-order": "1666025899-918",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚠 Mountain Cableway",
    "travel-href": "https://emojipedia.org/mountain-cableway/",
    emoji: "🚠",
    emojiName: "🚠 Mountain Cableway",
    description:
      "Mountain Cableway was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025904-920",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚟 Suspension Railway",
    "travel-href": "https://emojipedia.org/suspension-railway/",
    emoji: "🚟",
    emojiName: "🚟 Suspension Railway",
    description:
      "Similar to a monorail, a suspension railway is elevated, but the vehicle is suspended under the track.",
  },
  {
    "web-scraper-order": "1666025908-922",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚁 Helicopter",
    "travel-href": "https://emojipedia.org/helicopter/",
    emoji: "🚁",
    emojiName: "🚁 Helicopter",
    description:
      "A helicopter, which can hover in the air. Often seen in emergency circumstances such as transporting patients to a hospital, or for police or fire-fighting activity.",
  },
  {
    "web-scraper-order": "1666025912-924",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💺 Seat",
    "travel-href": "https://emojipedia.org/seat/",
    emoji: "💺",
    emojiName: "💺 Seat",
    description:
      "A seat, which could refer to any form of place to sit, with the distinction that a seat is generally fixed, and is not a chair which can be moved.",
  },
  {
    "web-scraper-order": "1666025916-925",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🪂 Parachute",
    "travel-href": "https://emojipedia.org/parachute/",
    emoji: "🪂",
    emojiName: "🪂 Parachute",
    description:
      "An open parachute floating through the air with a human steering. Most platforms feature a ram-air design. Colors vary across platforms.",
  },
  {
    "web-scraper-order": "1666025920-927",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛬 Airplane Arrival",
    "travel-href": "https://emojipedia.org/airplane-arrival/",
    emoji: "🛬",
    emojiName: "🛬 Airplane Arrival",
    description:
      "A plane approaching a runway for landing. Generally displayed left-right, with the front of the plane facing toward the ground in a position that may result in a crash if attempted in the real world.",
  },
  {
    "web-scraper-order": "1666025924-929",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛫 Airplane Departure",
    "travel-href": "https://emojipedia.org/airplane-departure/",
    emoji: "🛫",
    emojiName: "🛫 Airplane Departure",
    description:
      "A plane taking off from a runway. Generally displayed left-right, with the front of the plane elevated.",
  },
  {
    "web-scraper-order": "1666025929-931",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛩️ Small Airplane",
    "travel-href": "https://emojipedia.org/small-airplane/",
    emoji: "🛩️",
    emojiName: "🛩️ Small Airplane",
    description:
      "A light aircraft which is shown with propellers on some platforms.",
  },
  {
    "web-scraper-order": "1666025934-933",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "✈️ Airplane",
    "travel-href": "https://emojipedia.org/airplane/",
    emoji: "✈️",
    emojiName: "✈️ Airplane",
    description:
      "Used either as a literal airplane, to represent an overseas vacation, or sometimes as a proxy for airplane mode on a phone or tablet.",
  },
  {
    "web-scraper-order": "1666025939-935",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚢 Ship",
    "travel-href": "https://emojipedia.org/ship/",
    emoji: "🚢",
    emojiName: "🚢 Ship",
    description:
      "A large ship, used for transport of people or cargo across the ocean. May be a cruise ship, commonly found around tropical locations.",
  },
  {
    "web-scraper-order": "1666025943-938",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛥️ Motor Boat",
    "travel-href": "https://emojipedia.org/motor-boat/",
    emoji: "🛥️",
    emojiName: "🛥️ Motor Boat",
    description:
      "Motor Boat was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025949-943",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛴️ Ferry",
    "travel-href": "https://emojipedia.org/ferry/",
    emoji: "⛴️",
    emojiName: "⛴️ Ferry",
    description:
      "Ferry was approved as part of Unicode 5.2 in 2009 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025955-946",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛳️ Passenger Ship",
    "travel-href": "https://emojipedia.org/passenger-ship/",
    emoji: "🛳️",
    emojiName: "🛳️ Passenger Ship",
    description:
      "Passenger Ship was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025959-949",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚤 Speedboat",
    "travel-href": "https://emojipedia.org/speedboat/",
    emoji: "🚤",
    emojiName: "🚤 Speedboat",
    description:
      "A motorized speedboat used for recreation on lakes, or other bodies of water.",
  },
  {
    "web-scraper-order": "1666025962-951",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛵ Sailboat",
    "travel-href": "https://emojipedia.org/sailboat/",
    emoji: "⛵",
    emojiName: "⛵ Sailboat",
    description:
      "A sailboat, otherwise known as a sailing boat or yacht.  Uses wind as the source of propulsion to move around a body of water.",
  },
  {
    "web-scraper-order": "1666025965-954",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛟 Ring Buoy",
    "travel-href": "https://emojipedia.org/ring-buoy/",
    emoji: "🛟",
    emojiName: "🛟 Ring Buoy",
    description:
      "A round white and orange or red ring buoy with string laced through its perimeter. Also called a life preserver.",
  },
  {
    "web-scraper-order": "1666025967-957",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⚓ Anchor",
    "travel-href": "https://emojipedia.org/anchor/",
    emoji: "⚓",
    emojiName: "⚓ Anchor",
    description:
      "A metal device, dropped out of a boat to prevent it drifting away from the current location.",
  },
  {
    "web-scraper-order": "1666025969-959",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚧 Construction",
    "travel-href": "https://emojipedia.org/construction/",
    emoji: "🚧",
    emojiName: "🚧 Construction",
    description:
      "A sign used to indicate roadwork or construction. Generally shown as yellow and black diagonal stripes, and often used to physically block access to a road or area. May be used to imply a website or project in progress or under construction.",
  },
  {
    "web-scraper-order": "1666025971-962",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚦 Vertical Traffic Light",
    "travel-href": "https://emojipedia.org/vertical-traffic-light/",
    emoji: "🚦",
    emojiName: "🚦 Vertical Traffic Light",
    description:
      "A set of red, orange (amber) and green traffic lights, used at intersections. More common than the horizontal traffic light.",
  },
  {
    "web-scraper-order": "1666025974-964",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚥 Horizontal Traffic Light",
    "travel-href": "https://emojipedia.org/horizontal-traffic-light/",
    emoji: "🚥",
    emojiName: "🚥 Horizontal Traffic Light",
    description:
      "A set of red, orange (amber) and green traffic lights, used at intersections. Less common than the vertical traffic light.",
  },
  {
    "web-scraper-order": "1666025980-969",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚨 Police Car Light",
    "travel-href": "https://emojipedia.org/police-car-light/",
    emoji: "🚨",
    emojiName: "🚨 Police Car Light",
    description:
      "A revolving red light seen on top of a police car. Often used in emergency circumstances in addition to a siren making a loud warning sound.",
  },
  {
    "web-scraper-order": "1666025982-972",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛞 Wheel",
    "travel-href": "https://emojipedia.org/wheel/",
    emoji: "🛞",
    emojiName: "🛞 Wheel",
    description: "A wheel with a rubber tire.",
  },
  {
    "web-scraper-order": "1666025985-976",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛽ Fuel Pump",
    "travel-href": "https://emojipedia.org/fuel-pump/",
    emoji: "⛽",
    emojiName: "⛽ Fuel Pump",
    description: "A fuel pump, used to fill up a vehicle with gas / petrol.",
  },
  {
    "web-scraper-order": "1666025988-978",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛤️ Railway Track",
    "travel-href": "https://emojipedia.org/railway-track/",
    emoji: "🛤️",
    emojiName: "🛤️ Railway Track",
    description:
      "Railway Track was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025990-980",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛣️ Motorway",
    "travel-href": "https://emojipedia.org/motorway/",
    emoji: "🛣️",
    emojiName: "🛣️ Motorway",
    description:
      "A wide road shown from a first person perspective. Apple's artwork displays a road sign to Curpertino.",
  },
  {
    "web-scraper-order": "1666025993-983",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚏 Bus Stop",
    "travel-href": "https://emojipedia.org/bus-stop/",
    emoji: "🚏",
    emojiName: "🚏 Bus Stop",
    description:
      "A sign indicating the location of a bus stop by the side of a road.",
  },
  {
    "web-scraper-order": "1666025996-987",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛴 Kick Scooter",
    "travel-href": "https://emojipedia.org/kick-scooter/",
    emoji: "🛴",
    emojiName: "🛴 Kick Scooter",
    description: "A non-motorized scooter, with two wheels and handles.",
  },
  {
    "web-scraper-order": "1666026000-990",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚲 Bicycle",
    "travel-href": "https://emojipedia.org/bicycle/",
    emoji: "🚲",
    emojiName: "🚲 Bicycle",
    description:
      "A bicycle, sometimes called a push bike, used for transport or sport.",
  },
  {
    "web-scraper-order": "1666026003-994",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛺 Auto Rickshaw",
    "travel-href": "https://emojipedia.org/auto-rickshaw/",
    emoji: "🛺",
    emojiName: "🛺 Auto Rickshaw",
    description:
      "An auto rickshaw, often referred to as a tuk tuk. This motorized version of a cycle rickshaw is used for transport in many regions of the world. Generally this emoji has three wheels and open sides without doors.",
  },
  {
    "web-scraper-order": "1666026006-997",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛵 Motor Scooter",
    "travel-href": "https://emojipedia.org/motor-scooter/",
    emoji: "🛵",
    emojiName: "🛵 Motor Scooter",
    description:
      "A motor scooter, which may be displayed as any type of motorbike with or without a step-through frame. Distinct from the racing motorcycle, which is used for sport, not transport.",
  },
  {
    "web-scraper-order": "1666026009-999",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏍️ Motorcycle",
    "travel-href": "https://emojipedia.org/motorcycle/",
    emoji: "🏍️",
    emojiName: "🏍️ Motorcycle",
    description:
      "A motorcycle, otherwise known as a motorbike used for sport/racing purposes. For a transport-based motorcycle, use a motor scooter.",
  },
  {
    "web-scraper-order": "1666026011-1002",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏎️ Racing Car",
    "travel-href": "https://emojipedia.org/racing-car/",
    emoji: "🏎️",
    emojiName: "🏎️ Racing Car",
    description:
      "A racing car which appears as a formula one vehicle or rally car on most platforms. Generally displayed in red.",
  },
  {
    "web-scraper-order": "1666026015-1006",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚜 Tractor",
    "travel-href": "https://emojipedia.org/tractor/",
    emoji: "🚜",
    emojiName: "🚜 Tractor",
    description:
      "A tractor, may be used by a farmer or other occupation on the land.",
  },
  {
    "web-scraper-order": "1666026019-1009",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚛 Articulated Lorry",
    "travel-href": "https://emojipedia.org/articulated-lorry/",
    emoji: "🚛",
    emojiName: "🚛 Articulated Lorry",
    description:
      "Articulated Lorry was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026023-1013",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚚 Delivery Truck",
    "travel-href": "https://emojipedia.org/delivery-truck/",
    emoji: "🚚",
    emojiName: "🚚 Delivery Truck",
    description:
      "Delivery Truck was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026026-1016",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛻 Pickup Truck",
    "travel-href": "https://emojipedia.org/pickup-truck/",
    emoji: "🛻",
    emojiName: "🛻 Pickup Truck",
    description:
      "A red or turquoise pickup truck. Used to talk about trucks or modes of transportation in general.",
  },
  {
    "web-scraper-order": "1666026030-1019",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚙 Sport Utility Vehicle",
    "travel-href": "https://emojipedia.org/sport-utility-vehicle/",
    emoji: "🚙",
    emojiName: "🚙 Sport Utility Vehicle",
    description:
      "A blue or green Sport Utility Vehicle or station wagon, often with a spare tire on the back. Commonly used as a generic blue or green car.",
  },
  {
    "web-scraper-order": "1666026033-1022",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚘 Oncoming Automobile",
    "travel-href": "https://emojipedia.org/oncoming-automobile/",
    emoji: "🚘",
    emojiName: "🚘 Oncoming Automobile",
    description:
      "A car being shown from the front. The windscreen and hood (bonnet in British English) of the car can be seen facing forward.",
  },
  {
    "web-scraper-order": "1666026036-1025",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚗 Automobile",
    "travel-href": "https://emojipedia.org/automobile/",
    emoji: "🚗",
    emojiName: "🚗 Automobile",
    description:
      "A car shown from the side, facing right-to-left. Appears as a red car on almost all platforms (which goes faster), though earlier Google designs displayed the vehicle as either silver or blue.",
  },
  {
    "web-scraper-order": "1666026040-1028",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚖 Oncoming Taxi",
    "travel-href": "https://emojipedia.org/oncoming-taxi/",
    emoji: "🚖",
    emojiName: "🚖 Oncoming Taxi",
    description:
      "A yellow taxicab, iconically seen in New York City. Shown from the front, as opposed to the taxi emoji which displays the side of the vehicle.",
  },
  {
    "web-scraper-order": "1666026043-1032",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚕 Taxi",
    "travel-href": "https://emojipedia.org/taxi/",
    emoji: "🚕",
    emojiName: "🚕 Taxi",
    description:
      "A yellow taxicab, iconically seen in New York City. Shown from the side, as opposed to the oncoming taxi emoji.",
  },
  {
    "web-scraper-order": "1666026047-1034",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚔 Oncoming Police Car",
    "travel-href": "https://emojipedia.org/oncoming-police-car/",
    emoji: "🚔",
    emojiName: "🚔 Oncoming Police Car",
    description: "A police car, shown with an emergency light on the top.",
  },
  {
    "web-scraper-order": "1666026050-1036",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚓 Police Car",
    "travel-href": "https://emojipedia.org/police-car/",
    emoji: "🚓",
    emojiName: "🚓 Police Car",
    description: "A police car, shown with an emergency light on the top.",
  },
  {
    "web-scraper-order": "1666026053-1039",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚒 Fire Engine",
    "travel-href": "https://emojipedia.org/fire-engine/",
    emoji: "🚒",
    emojiName: "🚒 Fire Engine",
    description:
      "A red fire truck, an essential part of emergency services along with a police car or ambulance.",
  },
  {
    "web-scraper-order": "1666026057-1041",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚑 Ambulance",
    "travel-href": "https://emojipedia.org/ambulance/",
    emoji: "🚑",
    emojiName: "🚑 Ambulance",
    description:
      "An ambulance, used to transport patients between their home and the hospital.",
  },
  {
    "web-scraper-order": "1666026061-1044",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚐 Minibus",
    "travel-href": "https://emojipedia.org/minibus/",
    emoji: "🚐",
    emojiName: "🚐 Minibus",
    description:
      "A small bus or minivan designed to carry fewer people than a full-sized bus. Displayed in white on most platforms (green on Facebook).",
  },
  {
    "web-scraper-order": "1666026065-1047",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚎 Trolleybus",
    "travel-href": "https://emojipedia.org/trolleybus/",
    emoji: "🚎",
    emojiName: "🚎 Trolleybus",
    description:
      "A type of bus that uses overhead electrical wires for power. Appears similar to a cross between a bus and a tram car.",
  },
  {
    "web-scraper-order": "1666026068-1049",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚍 Oncoming Bus",
    "travel-href": "https://emojipedia.org/oncoming-bus/",
    emoji: "🚍",
    emojiName: "🚍 Oncoming Bus",
    description:
      "The front of a bus, showing the windscreen, as well as wing mirrors in some versions of this emoji.",
  },
  {
    "web-scraper-order": "1666026072-1052",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚌 Bus",
    "travel-href": "https://emojipedia.org/bus/",
    emoji: "🚌",
    emojiName: "🚌 Bus",
    description:
      "A bus used for public transport in cities and towns. Could also be used as a school bus.",
  },
  {
    "web-scraper-order": "1666026077-1054",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚋 Tram Car",
    "travel-href": "https://emojipedia.org/tram-car/",
    emoji: "🚋",
    emojiName: "🚋 Tram Car",
    description:
      "A form of public transport on rails, usually found on streets in cities or other urban areas. For short or medium-length journeys.",
  },
  {
    "web-scraper-order": "1666026080-1057",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚞 Mountain Railway",
    "travel-href": "https://emojipedia.org/mountain-railway/",
    emoji: "🚞",
    emojiName: "🚞 Mountain Railway",
    description: "A train and railway in the mountains.",
  },
  {
    "web-scraper-order": "1666026084-1059",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚝 Monorail",
    "travel-href": "https://emojipedia.org/monorail/",
    emoji: "🚝",
    emojiName: "🚝 Monorail",
    description:
      "Similar to a train, but running on a single track. Monorails are often found at theme parks, or other tourist destinations.",
  },
  {
    "web-scraper-order": "1666026087-1061",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚊 Tram",
    "travel-href": "https://emojipedia.org/tram/",
    emoji: "🚊",
    emojiName: "🚊 Tram",
    description:
      "A form of public transport on rails, usually found on streets in cities or other urban areas. For short or medium-length journeys.",
  },
  {
    "web-scraper-order": "1666026089-1063",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚉 Station",
    "travel-href": "https://emojipedia.org/station/",
    emoji: "🚉",
    emojiName: "🚉 Station",
    description:
      "A station, presumed to be a train station. Displays a train alongside a platform, where passengers can board.",
  },
  {
    "web-scraper-order": "1666026093-1066",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚈 Light Rail",
    "travel-href": "https://emojipedia.org/light-rail/",
    emoji: "🚈",
    emojiName: "🚈 Light Rail",
    description:
      "A form of public transport similar to a tram, but running on a track or network separated from cars and other types of traffic.",
  },
  {
    "web-scraper-order": "1666026095-1068",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚇 Metro",
    "travel-href": "https://emojipedia.org/metro/",
    emoji: "🚇",
    emojiName: "🚇 Metro",
    description:
      "A metro: frequent underground train found in built-up areas with high populations.",
  },
  {
    "web-scraper-order": "1666026097-1070",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚆 Train",
    "travel-href": "https://emojipedia.org/train/",
    emoji: "🚆",
    emojiName: "🚆 Train",
    description:
      "A train, of no specified type. Due to the presence of a steam train and fast train emoji, this is likely to be a regular electrified or diesel passenger train.",
  },
  {
    "web-scraper-order": "1666026101-1072",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚅 Bullet Train",
    "travel-href": "https://emojipedia.org/bullet-train/",
    emoji: "🚅",
    emojiName: "🚅 Bullet Train",
    description:
      "A high speed train, designed to cover long distances at high speed. Also features a streamlined bullet nose, often used in reference to the Shinkansen in Japan.",
  },
  {
    "web-scraper-order": "1666026103-1074",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚄 High-Speed Train",
    "travel-href": "https://emojipedia.org/high-speed-train/",
    emoji: "🚄",
    emojiName: "🚄 High-Speed Train",
    description:
      "A high speed train, designed to cover long distances at high speed.",
  },
  {
    "web-scraper-order": "1666026106-1076",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚃 Railway Car",
    "travel-href": "https://emojipedia.org/railway-car/",
    emoji: "🚃",
    emojiName: "🚃 Railway Car",
    description:
      "A railway (railroad) car (carriage) that is generally pulled along a railway line by a locomotive. Shown with a pantograph above the carriage on many platforms which makes it look more like a tram car.",
  },
  {
    "web-scraper-order": "1666026110-1078",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚂 Locomotive",
    "travel-href": "https://emojipedia.org/locomotive/",
    emoji: "🚂",
    emojiName: "🚂 Locomotive",
    description:
      "A steam train, powered by coal or wood. An early type of locomotive, now mostly replaced by electric or diesel trains.",
  },
  {
    "web-scraper-order": "1666026113-1081",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎢 Roller Coaster",
    "travel-href": "https://emojipedia.org/roller-coaster/",
    emoji: "🎢",
    emojiName: "🎢 Roller Coaster",
    description:
      "A roller coaster in a theme park going down a dip in the ride. Three carriages can be seen with two people in each red carriage.",
  },
  {
    "web-scraper-order": "1666026118-1084",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎡 Ferris Wheel",
    "travel-href": "https://emojipedia.org/ferris-wheel/",
    emoji: "🎡",
    emojiName: "🎡 Ferris Wheel",
    description: "A large rotating wheel, often found at a carnival or fair.",
  },
  {
    "web-scraper-order": "1666026120-1086",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛝 Playground Slide",
    "travel-href": "https://emojipedia.org/playground-slide/",
    emoji: "🛝",
    emojiName: "🛝 Playground Slide",
    description: "A slide with a ladder, as seen in children's playgrounds.",
  },
  {
    "web-scraper-order": "1666026123-1088",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎠 Carousel Horse",
    "travel-href": "https://emojipedia.org/carousel-horse/",
    emoji: "🎠",
    emojiName: "🎠 Carousel Horse",
    description:
      "A wooden painted horse, found on the carousel at a carnival. Faces to the left-of screen.",
  },
  {
    "web-scraper-order": "1666026126-1090",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌉 Bridge at Night",
    "travel-href": "https://emojipedia.org/bridge-at-night/",
    emoji: "🌉",
    emojiName: "🌉 Bridge at Night",
    description: "A lit-up bridge, shown at night.",
  },
  {
    "web-scraper-order": "1666026128-1092",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌇 Sunset",
    "travel-href": "https://emojipedia.org/sunset/",
    emoji: "🌇",
    emojiName: "🌇 Sunset",
    description:
      "A beautiful view, featuring an orange sky, with the sun setting over the buildings of a city skyline.",
  },
  {
    "web-scraper-order": "1666026130-1094",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌆 Cityscape at Dusk",
    "travel-href": "https://emojipedia.org/cityscape-at-dusk/",
    emoji: "🌆",
    emojiName: "🌆 Cityscape at Dusk",
    description:
      "A view of city buildings as the last light disappears from the sky. An orange (or blue) glow lingers, before the stars of the night sky become visible.",
  },
  {
    "web-scraper-order": "1666026133-1096",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌅 Sunrise",
    "travel-href": "https://emojipedia.org/sunrise/",
    emoji: "🌅",
    emojiName: "🌅 Sunrise",
    description:
      "A sun rising, early in the morning. Can be difficult to distinguish from a sunset in some versions of this artwork.",
  },
  {
    "web-scraper-order": "1666026135-1098",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌄 Sunrise Over Mountains",
    "travel-href": "https://emojipedia.org/sunrise-over-mountains/",
    emoji: "🌄",
    emojiName: "🌄 Sunrise Over Mountains",
    description: "The sun rising over a mountain range, early in the morning.",
  },
  {
    "web-scraper-order": "1666026138-1100",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏙️ Cityscape",
    "travel-href": "https://emojipedia.org/cityscape/",
    emoji: "🏙️",
    emojiName: "🏙️ Cityscape",
    description:
      "Cityscape was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026140-1102",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌃 Night with Stars",
    "travel-href": "https://emojipedia.org/night-with-stars/",
    emoji: "🌃",
    emojiName: "🌃 Night with Stars",
    description:
      "A night sky with stars, depicted on major platforms as a cityscape at night.",
  },
  {
    "web-scraper-order": "1666026143-1104",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌁 Foggy",
    "travel-href": "https://emojipedia.org/foggy/",
    emoji: "🌁",
    emojiName: "🌁 Foggy",
    description:
      "Foggy weather displayed as fog covering a bridge or cityscape, depending on the platform. For platforms that show a bridge, the red Golden Gate Bridge is generally displayed.",
  },
  {
    "web-scraper-order": "1666026145-1106",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛺ Tent",
    "travel-href": "https://emojipedia.org/tent/",
    emoji: "⛺",
    emojiName: "⛺ Tent",
    description: "A tent, used for protection from wind and rain when camping.",
  },
  {
    "web-scraper-order": "1666026148-1108",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛲ Fountain",
    "travel-href": "https://emojipedia.org/fountain/",
    emoji: "⛲",
    emojiName: "⛲ Fountain",
    description:
      "A water fountain, found in a park or other public space. Used for decorative purposes. A variety of styles of fountain are shown across different platforms.",
  },
  {
    "web-scraper-order": "1666026151-1110",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🕋 Kaaba",
    "travel-href": "https://emojipedia.org/kaaba/",
    emoji: "🕋",
    emojiName: "🕋 Kaaba",
    description:
      "A cube-shaped building located at the centre of the Al-Masjid al-Haram Mosque in Mecca.",
  },
  {
    "web-scraper-order": "1666026154-1112",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛩️ Shinto Shrine",
    "travel-href": "https://emojipedia.org/shinto-shrine/",
    emoji: "⛩️",
    emojiName: "⛩️ Shinto Shrine",
    description:
      "A shrine used for the Japanese Shinto religion. This emoji generally displays the torii, which is the gate to the Shinto Shrine. The torii is generally a red colored structure, with a curved roof section above two posts.",
  },
  {
    "web-scraper-order": "1666026156-1114",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🕍 Synagogue",
    "travel-href": "https://emojipedia.org/synagogue/",
    emoji: "🕍",
    emojiName: "🕍 Synagogue",
    description:
      "A synague; a place of worship for followers of Judaism. Displayed with a Star of David on the front.",
  },
  {
    "web-scraper-order": "1666026159-1116",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛕 Hindu Temple",
    "travel-href": "https://emojipedia.org/hindu-temple/",
    emoji: "🛕",
    emojiName: "🛕 Hindu Temple",
    description:
      "A Hindu temple or mandir; a place of worship for followers of Hinduism. Depicted on most platforms as a red, orange, or golden building with a tall spire.",
  },
  {
    "web-scraper-order": "1666026161-1118",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🕌 Mosque",
    "travel-href": "https://emojipedia.org/mosque/",
    emoji: "🕌",
    emojiName: "🕌 Mosque",
    description:
      "A mosque building, a place of worship for followers of Islam. Shown with a domed roof and a minaret.",
  },
  {
    "web-scraper-order": "1666026163-1120",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛪ Church",
    "travel-href": "https://emojipedia.org/church/",
    emoji: "⛪",
    emojiName: "⛪ Church",
    description:
      "A church building, generally associated with Christian denominations. In addition quiet prayer, churches hold regular worship services, weddings, baptisms and funerals.",
  },
  {
    "web-scraper-order": "1666026166-1122",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗽 Statue of Liberty",
    "travel-href": "https://emojipedia.org/statue-of-liberty/",
    emoji: "🗽",
    emojiName: "🗽 Statue of Liberty",
    description:
      "The Statue of Liberty, often used as a depiction of New York City.",
  },
  {
    "web-scraper-order": "1666026168-1124",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗼 Tokyo Tower",
    "travel-href": "https://emojipedia.org/tokyo-tower/",
    emoji: "🗼",
    emojiName: "🗼 Tokyo Tower",
    description:
      "The Tokyo Tower is the second-tallest building in Japan, located in Minato, Tokyo.",
  },
  {
    "web-scraper-order": "1666026170-1126",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💒 Wedding",
    "travel-href": "https://emojipedia.org/wedding/",
    emoji: "💒",
    emojiName: "💒 Wedding",
    description:
      "An emoji to depict a wedding, displayed by most vendors as a Christian church and love hearts. Some platforms display a cross or bell on the building.",
  },
  {
    "web-scraper-order": "1666026173-1128",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏰 Castle",
    "travel-href": "https://emojipedia.org/castle/",
    emoji: "🏰",
    emojiName: "🏰 Castle",
    description:
      "A castle, in a style that can be found in France and other parts of Europe.",
  },
  {
    "web-scraper-order": "1666026175-1130",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏯 Japanese Castle",
    "travel-href": "https://emojipedia.org/japanese-castle/",
    emoji: "🏯",
    emojiName: "🏯 Japanese Castle",
    description:
      "A traditional Japanese Castle (城, shiro or jō), usually made from stone and wood.",
  },
  {
    "web-scraper-order": "1666026177-1131",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏭 Factory",
    "travel-href": "https://emojipedia.org/factory/",
    emoji: "🏭",
    emojiName: "🏭 Factory",
    description:
      "An industrial factory, with flue-gas stacks releasing exhaust into the air.",
  },
  {
    "web-scraper-order": "1666026180-1133",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏬 Department Store",
    "travel-href": "https://emojipedia.org/department-store/",
    emoji: "🏬",
    emojiName: "🏬 Department Store",
    description:
      "A large department store, selling a range of products to the general public. Shown as a large building with a billboard.",
  },
  {
    "web-scraper-order": "1666026182-1135",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏫 School",
    "travel-href": "https://emojipedia.org/school/",
    emoji: "🏫",
    emojiName: "🏫 School",
    description:
      "A school building with multiple storeys, and a clock on the front. A place that children, or teenagers attend for their education.",
  },
  {
    "web-scraper-order": "1666026184-1137",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏪 Convenience Store",
    "travel-href": "https://emojipedia.org/convenience-store/",
    emoji: "🏪",
    emojiName: "🏪 Convenience Store",
    description:
      "A shop that is generally open for longer hours than a regular supermarket, sometimes 24 hours per day.",
  },
  {
    "web-scraper-order": "1666026186-1139",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏩 Love Hotel",
    "travel-href": "https://emojipedia.org/love-hotel/",
    emoji: "🏩",
    emojiName: "🏩 Love Hotel",
    description:
      "A love hotel is a hotel that can be hired by the hour instead of as accommodation for the evening.",
  },
  {
    "web-scraper-order": "1666026189-1141",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏨 Hotel",
    "travel-href": "https://emojipedia.org/hotel/",
    emoji: "🏨",
    emojiName: "🏨 Hotel",
    description:
      "A hotel building, displayed on most platforms as a building with many windows and a letter H on the front.",
  },
  {
    "web-scraper-order": "1666026191-1143",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏦 Bank",
    "travel-href": "https://emojipedia.org/bank/",
    emoji: "🏦",
    emojiName: "🏦 Bank",
    description:
      "A retail bank branch, where people can perform money-related tasks. Also a common location to find an ATM.",
  },
  {
    "web-scraper-order": "1666026193-1145",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏥 Hospital",
    "travel-href": "https://emojipedia.org/hospital/",
    emoji: "🏥",
    emojiName: "🏥 Hospital",
    description:
      "A place where people are taken to receive medical care. This hospital has a large red cross on the front, often used as a symbol for health care.",
  },
  {
    "web-scraper-order": "1666026197-1147",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏤 Post Office",
    "travel-href": "https://emojipedia.org/post-office/",
    emoji: "🏤",
    emojiName: "🏤 Post Office",
    description:
      "A European-style post office. A postal horn can be seen on the front, which is commonly found in the logos of European Postal Services.",
  },
  {
    "web-scraper-order": "1666026200-1149",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏣 Japanese Post Office",
    "travel-href": "https://emojipedia.org/japanese-post-office/",
    emoji: "🏣",
    emojiName: "🏣 Japanese Post Office",
    description:
      "A Japanese post office, featuring the 〒 Japanese postal mark on the front of the building.",
  },
  {
    "web-scraper-order": "1666026202-1151",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏢 Office Building",
    "travel-href": "https://emojipedia.org/office-building/",
    emoji: "🏢",
    emojiName: "🏢 Office Building",
    description:
      "A generic, high-rise office building. Generally found in cities, and most active during business hours.",
  },
  {
    "web-scraper-order": "1666026204-1153",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏡 House with Garden",
    "travel-href": "https://emojipedia.org/house-with-garden/",
    emoji: "🏡",
    emojiName: "🏡 House with Garden",
    description:
      "A suburban-looking house, with a tree, flower, or shrubs around it in the garden.",
  },
  {
    "web-scraper-order": "1666026207-1155",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏠 House",
    "travel-href": "https://emojipedia.org/house/",
    emoji: "🏠",
    emojiName: "🏠 House",
    description:
      "A house, otherwise known as a home when someone is living in it. Suitable for a couple or larger family, other perhaps housemates.",
  },
  {
    "web-scraper-order": "1666026209-1157",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏚️ Derelict House",
    "travel-href": "https://emojipedia.org/derelict-house/",
    emoji: "🏚️",
    emojiName: "🏚️ Derelict House",
    description:
      "A house which is unoccupied, and has become derelict. In a state of disrepair.",
  },
  {
    "web-scraper-order": "1666026211-1159",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏘️ Houses",
    "travel-href": "https://emojipedia.org/houses/",
    emoji: "🏘️",
    emojiName: "🏘️ Houses",
    description: "Multiple houses.",
  },
  {
    "web-scraper-order": "1666026215-1161",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛖 Hut",
    "travel-href": "https://emojipedia.org/hut/",
    emoji: "🛖",
    emojiName: "🛖 Hut",
    description:
      "A round hut with a thatched roof. Used to talk about huts, cottages, yurts, or homes in general.",
  },
  {
    "web-scraper-order": "1666026218-1163",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏗️ Building Construction",
    "travel-href": "https://emojipedia.org/building-construction/",
    emoji: "🏗️",
    emojiName: "🏗️ Building Construction",
    description:
      "A construction site generally depicted as a tower crane shown lifting steel or other building materials.",
  },
  {
    "web-scraper-order": "1666026220-1165",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏛️ Classical Building",
    "travel-href": "https://emojipedia.org/classical-building/",
    emoji: "🏛️",
    emojiName: "🏛️ Classical Building",
    description:
      "A building shown with columns in a classical style, sometimes used to represent a courthouse, town hall, post office or stock exchange.",
  },
  {
    "web-scraper-order": "1666026222-1167",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏟️ Stadium",
    "travel-href": "https://emojipedia.org/stadium/",
    emoji: "🏟️",
    emojiName: "🏟️ Stadium",
    description:
      "A large capacity stadium, featuring a large amount of seating for sporting fans, or people attending other shows hosted by the stadium.",
  },
  {
    "web-scraper-order": "1666026225-1169",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏞️ National Park",
    "travel-href": "https://emojipedia.org/national-park/",
    emoji: "🏞️",
    emojiName: "🏞️ National Park",
    description:
      "A national park, generally displayed with mountains, a river or stream, and trees.",
  },
  {
    "web-scraper-order": "1666026227-1171",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏝️ Desert Island",
    "travel-href": "https://emojipedia.org/desert-island/",
    emoji: "🏝️",
    emojiName: "🏝️ Desert Island",
    description:
      "Desert Island was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026230-1173",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏜️ Desert",
    "travel-href": "https://emojipedia.org/desert/",
    emoji: "🏜️",
    emojiName: "🏜️ Desert",
    description:
      "Desert was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026232-1175",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏖️ Beach with Umbrella",
    "travel-href": "https://emojipedia.org/beach-with-umbrella/",
    emoji: "🏖️",
    emojiName: "🏖️ Beach with Umbrella",
    description:
      "A beach showing sand, and an umbrella for protection from the sun.",
  },
  {
    "web-scraper-order": "1666026235-1177",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏕️ Camping",
    "travel-href": "https://emojipedia.org/camping/",
    emoji: "🏕️",
    emojiName: "🏕️ Camping",
    description:
      "A campsite featuring a tent and a tree, and perhaps a campfire. Similar to the tent emoji.",
  },
  {
    "web-scraper-order": "1666026237-1179",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗻 Mount Fuji",
    "travel-href": "https://emojipedia.org/mount-fuji/",
    emoji: "🗻",
    emojiName: "🗻 Mount Fuji",
    description:
      "Mount Fuji (called Fuji-san in Japan) is the largest mountain in Japan. Often seen with snow on the peak in colder months of the year.",
  },
  {
    "web-scraper-order": "1666026239-1181",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌋 Volcano",
    "travel-href": "https://emojipedia.org/volcano/",
    emoji: "🌋",
    emojiName: "🌋 Volcano",
    description: "A volcano, erupting with smoke and lava.",
  },
  {
    "web-scraper-order": "1666026242-1183",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛰️ Mountain",
    "travel-href": "https://emojipedia.org/mountain/",
    emoji: "⛰️",
    emojiName: "⛰️ Mountain",
    description:
      "A mountain shown with two peaks and blue sky. Similar to the snow capped mountain emoji.",
  },
  {
    "web-scraper-order": "1666026244-1185",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏔️ Snow-Capped Mountain",
    "travel-href": "https://emojipedia.org/snow-capped-mountain/",
    emoji: "🏔️",
    emojiName: "🏔️ Snow-Capped Mountain",
    description:
      "A mountain with snow resting at higher altitudes. Similar in appearance to the Mount Fuji emoji.",
  },
  {
    "web-scraper-order": "1666026247-1187",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗾 Map of Japan",
    "travel-href": "https://emojipedia.org/map-of-japan/",
    emoji: "🗾",
    emojiName: "🗾 Map of Japan",
    description:
      "Shows a map of the country of Japan, which is the only country to have its own emoji map. Other countries can be found on the various globe emojis, or the world map emoji.",
  },
  {
    "web-scraper-order": "1666026249-1189",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚣 Person Rowing Boat",
    "travel-href": "https://emojipedia.org/person-rowing-boat/",
    emoji: "🚣",
    emojiName: "🚣 Person Rowing Boat",
    description:
      "A small rowboat suitable for a small number of people. Couples or families sometimes hire these as an activity on calm waters.",
  },
];
export default travel;
